import React from 'react';
import { HelpCircleIcon, TargetIcon, LockIcon, BriefcaseIcon, CompassIcon } from 'lucide-react';
export function StrategicQuestions() {
  const questions = [{
    engagingHeading: 'Wie steht Polytec finanziell im Vergleich?',
    icon: <TargetIcon className="w-5 h-5 text-passion-red" data-id="element-87" />,
    answer: 'Polytec zeigt den stärksten operativen Turnaround im Feld. Röchling ist zwar profitabler, aber Polytecs Dynamik übertrifft alle Wettbewerber. ElringKlinger und Woco stecken tief in den roten Zahlen.'
  }, {
    engagingHeading: 'Wo liegen Polytecs strategische Chancen?',
    icon: <CompassIcon className="w-5 h-5 text-azure" data-id="element-88" />,
    answer: 'Die Diversifikation in nicht-automotive Bereiche (BOOXit, Militärlogistik) verschafft Polytec einen einzigartigen Vorteil. Während ElringKlinger alles auf Batterien setzt, streut Polytec das Risiko intelligent.'
  }, {
    engagingHeading: 'Welche Wettbewerber-Patente sollte Polytec beobachten?',
    icon: <LockIcon className="w-5 h-5 text-light-blue" data-id="element-89" />,
    answer: 'ElringKlingers 8 Patente im Bereich elektrochemischer Geräte signalisieren eine klare Abkehr vom klassischen Zuliefergeschäft. Röchling und Woco sind hier inaktiv — ein mögliches Warnsignal für deren Innovationskraft.'
  }, {
    engagingHeading: 'Wo kann Polytec Marktanteile gewinnen?',
    icon: <BriefcaseIcon className="w-5 h-5 text-light-green" data-id="element-90" />,
    answer: 'ElringKlingers Werksschließungen und Wocos Intransparenz verunsichern Kunden. Polytecs Stabilität und neue Partnerschaften positionieren das Unternehmen ideal, um freiwerdendes Geschäft aufzufangen.'
  }];
  return <section className="mb-16" data-id="element-91">
      <div className="flex items-center gap-3 mb-6" data-id="element-92">
        <div className="bg-tech-grey text-white p-2 rounded-lg" data-id="element-93">
          <HelpCircleIcon className="w-5 h-5" data-id="element-94" />
        </div>
        <h2 className="font-heading text-2xl font-bold text-tech-grey" data-id="element-95">
          Strategische Fragen für Polytec
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-96">
        {questions.map((q, index) => <div key={index} className="bg-white rounded-xl shadow-sm border border-tech-grey-25/50 p-6 flex flex-col h-full" data-id="element-97">
            <div className="flex items-start justify-between mb-4" data-id="element-98">
              <div data-id="element-99">
                <h3 className="font-heading text-xl font-bold text-tech-grey" data-id="element-100">
                  {q.engagingHeading}
                </h3>
              </div>
              <div className="bg-tech-grey-10 p-2 rounded-lg shrink-0 ml-4" data-id="element-101">
                {q.icon}
              </div>
            </div>
            <p className="font-body text-tech-grey-75 leading-relaxed mt-auto" data-id="element-102">
              {q.answer}
            </p>
          </div>)}
      </div>
    </section>;
}